var Shopify = Shopify || {};

Shopify.addItem = function(t, r, e) {
    var o = {
        type: "POST",
        url: _bc_config.cart_add_url + ".js",
        data: "quantity=" + (r = r || 1) + "&id=" + t,
        dataType: "json",
        success: function(t) {
            "function" == typeof e ? e(t) : Shopify.onItemAdded(t)
        },
        error: function(t, r) {
            Shopify.onError(t, r)
        }
    };
    jQuery.ajax(o)
}
,
Shopify.addItemFromForm = function(t, r) {
    var e = {
        type: "POST",
        url: _bc_config.cart_add_url + ".js",
        data: jQuery("#" + t).serialize(),
        dataType: "json",
        success: function(t) {
            "function" == typeof r ? r(t) : Shopify.onItemAdded(t)
        },
        error: function(t, r) {
            Shopify.onError(t, r)
        }
    };
    jQuery.ajax(e)
}
,
Shopify.getCart = function(r) {
    jQuery.getJSON(_bc_config.cart_url+".js", function(t) {
        "function" == typeof r ? r(t) : Shopify.onCartUpdate(t)
    })
}
,
Shopify.pollForCartShippingRatesForDestination = function(o, a, t) {
    t = t || Shopify.onError;
    var n = function() {
        jQuery.ajax("/cart/async_shipping_rates", {
            dataType: "json",
            success: function(t, r, e) {
                200 === e.status ? "function" == typeof a ? a(t.shipping_rates, o) : Shopify.onCartShippingRatesUpdate(t.shipping_rates, o) : setTimeout(n, 500)
            },
            error: t
        })
    };
    return n
}
,
Shopify.getCartShippingRatesForDestination = function(t, r, e) {
    e = e || Shopify.onError;
    var o = {
        type: "POST",
        url: "/cart/prepare_shipping_rates",
        data: Shopify.param({
            shipping_address: t
        }),
        success: Shopify.pollForCartShippingRatesForDestination(t, r, e),
        error: e
    };
    jQuery.ajax(o)
}
,
Shopify.getProduct = function(t, r) {
    jQuery.getJSON("/products/" + t + ".js", function(t) {
        "function" == typeof r ? r(t) : Shopify.onProduct(t)
    })
}
,
Shopify.changeItem = function(t, r, e) {
    var o = {
        type: "POST",
        url: _bc_config.cart_change_url + ".js",
        data: "quantity=" + r + "&id=" + t,
        dataType: "json",
        success: function(t) {
            "function" == typeof e ? e(t) : Shopify.onCartUpdate(t)
        },
        error: function(t, r) {
            Shopify.onError(t, r)
        }
    };
    jQuery.ajax(o)
}
,
Shopify.removeItem = function(t, r) {
    var e = {
        type: "POST",
        url: _bc_config.cart_change_url + ".js",
        data: "quantity=0&id=" + t,
        dataType: "json",
        success: function(t) {
            "function" == typeof r ? r(t) : Shopify.onCartUpdate(t)
        },
        error: function(t, r) {
            Shopify.onError(t, r)
        }
    };
    jQuery.ajax(e)
}
,
Shopify.clear = function(r) {
    var t = {
        type: "POST",
        url: _bc_config.cart_clear_url + ".js",
        data: "",
        dataType: "json",
        success: function(t) {
            "function" == typeof r ? r(t) : Shopify.onCartUpdate(t)
        },
        error: function(t, r) {
            Shopify.onError(t, r)
        }
    };
    jQuery.ajax(t)
}
,
Shopify.updateCartFromForm = function(t, r) {
    var e = {
        type: "POST",
        url: _bc_config.cart_update_url + ".js",
        data: jQuery("#" + t).serialize(),
        dataType: "json",
        success: function(t) {
            "function" == typeof r ? r(t) : Shopify.onCartUpdate(t)
        },
        error: function(t, r) {
            Shopify.onError(t, r)
        }
    };
    jQuery.ajax(e)
}
,
Shopify.updateCartAttributes = function(t, r) {
    var o = "";
    jQuery.isArray(t) ? jQuery.each(t, function(t, r) {
        var e = attributeToString(r.key);
        "" !== e && (o += "attributes[" + e + "]=" + attributeToString(r.value) + "&")
    }) : "object" == typeof t && null !== t && jQuery.each(t, function(t, r) {
        o += "attributes[" + attributeToString(t) + "]=" + attributeToString(r) + "&"
    });
    var e = {
        type: "POST",
        url: _bc_config.cart_update_url + ".js",
        data: o,
        dataType: "json",
        success: function(t) {
            "function" == typeof r ? r(t) : Shopify.onCartUpdate(t)
        },
        error: function(t, r) {
            Shopify.onError(t, r)
        }
    };
    jQuery.ajax(e)
}